import React from 'react';
import { connect } from 'react-redux';
import { Col } from 'react-bootstrap';
import logoinspire from '../MapHeader/img/logo-inspire.png';
import herbCieszanow from './Cieszanow.jpg';
import herbKrosno from './KrosnoHerb.png';
import s from './PrintHeader.scss';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

const mapState = state => ({
  districtName: state.district && state.district.district ? state.district.district.nazwa : null,
  routing: state.routing,
  parcel_id: state.postGeoData.parcel_id,
  printModalStatus: state.printSettings.printModalStatus,
  zoomLevel: state.routing.zoomLevel,
  layer: state.layers.currentMapComposition,
});

const plusZero = (date) => {
  const newFormat = date.toString();
  if (newFormat.length === 1) {
    return ('0').concat(newFormat);
  }
  return newFormat;
};

const printDate = () => {
  const currentDate = new Date();
  const data = currentDate.getFullYear() + "." +
  plusZero(currentDate.getMonth()) + "." +
  plusZero(currentDate.getDate()) + " - " +
  plusZero(currentDate.getHours()) + ":" +
  plusZero(currentDate.getMinutes());
  return data;
};

const PrintHeader = props => {
  return (
    props.printModalStatus === true ?
      (<div className={'printHeader'} >
        <Col xs={5} className={'print-left-col'}>
          <img
            src={logoinspire}
            alt="Logo Inspire"
          />
        </Col>
        <Col xs={1} className={'print-middle-col'}>
          {/*Zoom: {props.zoomLevel}*/}
        </Col>
        <Col xs={5} className={'print-right-col'}>
          {props.districtName}, {printDate()}
          <br />
          {props.parcel_id ? ` Działka: ${props.parcel_id}` : null}
          {props.layer.nazwa !== 'kompozycyjka' ? ` Warstwa: ${props.layer.nazwa}` : null}
        </Col>
        <Col xs={1} className={'print-right-col'}>
          <img
            className={'print-herb'}
            src={props.districtName !== 'Miasto Krosno' ? herbCieszanow : herbKrosno}
            alt="Herb Urzędu"
          />
        </Col>
      </div >)
      : null
  );
};

export default withStyles(s)(connect(mapState)(PrintHeader));




// WEBPACK FOOTER //
// src/components/PrintHeader/PrintHeader.js